export default function Footer() {
  return (
    <footer className="bg-black py-10 sm:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col items-center justify-center gap-5 sm:gap-6 mb-6 sm:mb-8">
          <img
            alt="Four Models"
            className="h-14 sm:h-20 object-contain"
            src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/f6ba88513f846dcaf1ba402d9a75d603.png"
          />
          <div className="text-center">
            <p className="text-white font-bold text-base sm:text-lg mb-1">
              Seletiva Presencial Four Models
            </p>
            <p className="text-gray-400 text-sm">08 de Abril às 19:30</p>
            <p className="text-gray-400 text-sm">Tri Hotel & Flat</p>
            <p className="text-gray-400 text-sm">Rua Os Dezoito do Forte, 1818 - São Pelegrino, Caxias do Sul - RS</p>
          </div>
          <div className="flex items-center gap-5 text-gray-400">
            <a
              href="https://www.instagram.com/fourmodelsoficial/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl" />
            </a>
            <a
              href="https://www.facebook.com/fourmodelsoficial"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-circle-line text-xl" />
            </a>
            <a
              href="https://whatsa.me/5551998977297/?t=Tenho%20d%C3%BAvidas%20sobre%20a%20sele%C3%A7%C3%A3o%20de%20Caxias%20do%20Sul%20-%20RS%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es!"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl" />
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5 text-center">
          <p className="text-gray-500 text-xs">
            © 2026 Four Models. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
